import axios from 'axios';
import { getApiBaseUrl } from '../config';

const getAuthHeader = () => {
    const token = localStorage.getItem('parentToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const examService = {
    getAcademicSessions: async () => {
        const response = await axios.get(`${getApiBaseUrl()}/academic-sessions`, {
            headers: getAuthHeader()
        });
        return response.data;
    },

    getExamTypes: async () => {
        const response = await axios.get(`${getApiBaseUrl()}/exam-types`, {
            headers: getAuthHeader()
        });
        return response.data;
    },

    getExamSchedule: async (academicSessionId, classId, examTypeId) => {
        const response = await axios.get(`${getApiBaseUrl()}/exam-schedule`, {
            params: {
                academicSessionId,
                classId,
                examTypeId,
                onlyPublished: true
            },
            headers: getAuthHeader()
        });
        return response.data;
    },

    getAdmitCard: async (enrollmentId) => {
        const response = await axios.get(`${getApiBaseUrl()}/admit-cards/enrollment/${enrollmentId}`, {
            headers: getAuthHeader()
        });
        return response.data;
    }
};
